import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Создать группу ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Создать учетку ")


import { useResponsiblingsStore } from '@/store/responsiblings/responsiblingsModule';
import { useMainStore } from '@/store';
import TableComponent from '@/components/TableComponent/TableComponent.vue';
import { storeToRefs } from 'pinia';
import {
  Action, ITable, SelectionType, TableStructure,
} from '@/components/TableComponent/types';
import { actionHandler } from '@/actions/actionHandler';
import {
  computed, ComputedRef, Ref, ref,
} from 'vue';
import { useOrgsStore } from '@/store/orgs/orgsModule';
import { ILoginGroup, IAccountType, IAccount } from '@/store/responsiblings/types';
import { contactsStructure } from './contactsTableStructure';

const accountTypesCustomStructure: TableStructure = {
  field_id: 'id',
  selection: SelectionType.SINGLE,
  columns: [
    {
      name_column: 'id',
      colname: 'ID',
      visible: true,
      content_type: 'default',
    },
    {
      name_column: 'name',
      colname: '',
      visible: true,
      content_type: 'default',
    },
  ],
};

const __default__ = { name: 'ContactsView' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  async setup(__props) {

let __temp: any, __restore: any

const vertSplitterModel = ref(66);
const horSplitterModel = ref(50);

const responsiblingsStore = useResponsiblingsStore();
const mainStore = useMainStore();

const { responsiblingsList } = storeToRefs(responsiblingsStore);
const { currentOrgId } = storeToRefs(useOrgsStore());
if (!responsiblingsList.value.data && currentOrgId.value) {
  (
  ([__temp,__restore] = _withAsyncContext(() => responsiblingsStore.loadResponsiblings())),
  await __temp,
  __restore()
);
}

const accountTypes = ref(null) as Ref<ITable<IAccountType> | null>;

const selectedGroup = ref(null) as Ref<null | ILoginGroup>;
const selectedAccountType = ref(null) as Ref<null | IAccountType>;

const { loginsGroups } = storeToRefs(responsiblingsStore);
if (!loginsGroups.value.data) {
  (
  ([__temp,__restore] = _withAsyncContext(() => responsiblingsStore.loadLoginsGroups())),
  await __temp,
  __restore()
);
}

const getAccountTypes = (
  ([__temp,__restore] = _withAsyncContext(() => mainStore.dispatchEvent(
  'GET:account_types',
  { id_org: currentOrgId },
))),
  __temp = await __temp,
  __restore(),
  __temp
);
if (getAccountTypes && typeof getAccountTypes !== 'boolean') {
  accountTypes.value = getAccountTypes as ITable<IAccountType>;
}
const selectGroup = (val: number[]) => {
  const group = loginsGroups?.value?.data
    .find((group) => group.id === val[0]);
  if (group) {
    selectedGroup.value = group;
  }
};
const selectAccountType = (val: number[]) => {
  const type = accountTypes?.value?.data
    .find((type) => type.id === val[0]);
  if (type) {
    selectedAccountType.value = type;
  }
};

const { selectedContact } = storeToRefs(responsiblingsStore);

const createAccountAction: ComputedRef<Action> = computed(() => ({
  name: 'AccountCreateModal',
  type: 'modal',
  customParam: JSON.stringify({
    group: selectedGroup.value,
    type: selectedAccountType.value,
  }),
}));

const createAccoutGroup: Action = {
  name: 'AccountGroupCreateModal',
  type: 'modal',
};

const createContactAction: Action = {
  name: 'ContactCreateModal',
  type: 'modal',
};

// const canCreateAccount = true;

const canCreateAccount = computed(() => selectedContact.value
    && selectedContact.value.value_type === 'e-mail'
    && selectedGroup.value
    && selectedAccountType.value);


return (_ctx: any,_cache: any) => {
  const _component_q_splitter = _resolveComponent("q-splitter")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_fab_action = _resolveComponent("q-fab-action")!
  const _component_q_fab = _resolveComponent("q-fab")!
  const _component_q_page_sticky = _resolveComponent("q-page-sticky")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_splitter, {
        style: {"height":"100%","width":"100%"},
        modelValue: vertSplitterModel.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((vertSplitterModel).value = $event))
      }, {
        before: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            (_unref(responsiblingsList).data?.length)
              ? (_openBlock(), _createBlock(TableComponent, {
                  key: 0,
                  tableId: "respons-table",
                  table: _unref(responsiblingsList),
                  structure: _unref(contactsStructure)
                }, null, 8, ["table", "structure"]))
              : _createCommentVNode("", true)
          ])
        ]),
        after: _withCtx(() => [
          _createVNode(_component_q_splitter, {
            horizontal: "",
            modelValue: horSplitterModel.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((horSplitterModel).value = $event))
          }, {
            before: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (_unref(loginsGroups))
                  ? (_openBlock(), _createBlock(TableComponent, {
                      key: 0,
                      tableId: "logins-table",
                      table: _unref(loginsGroups),
                      structure: _unref(loginsGroups).structure,
                      onSelection: selectGroup
                    }, null, 8, ["table", "structure"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            after: _withCtx(() => [
              (_unref(accountTypes))
                ? (_openBlock(), _createBlock(TableComponent, {
                    key: 0,
                    tableId: "accs-table",
                    table: _unref(accountTypes),
                    structure: accountTypesCustomStructure,
                    "use-trust": false,
                    onSelection: selectAccountType
                  }, null, 8, ["table"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_q_page_sticky, {
      position: "bottom-right",
      offset: [18, 18]
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_fab, {
          color: "accent",
          icon: "add",
          direction: "up"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_fab_action, {
              color: "accent",
              icon: "group_add",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(actionHandler)(createAccoutGroup)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_fab_action, {
              color: "accent",
              icon: "person_add",
              disable: !_unref(responsiblingsList).data?.length || !_unref(canCreateAccount),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(actionHandler)(_unref(createAccountAction))))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disable"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})